module.exports = __webpack_public_path__ + "static/media/uphie_logo_small.2e737354.png";